/** Isolated mainnet TEST instance; changing Root must also isolate pending UI state. */
export const TREASURY_TRIAL_ROOT = "EQCCacfnHe6c3P_cxSTKgYO2Gp-VaT2bS651OJWb0thgKuWO";

/** PROD is an explicit build target. Never inherit TEST pending purchases. */
export const TREASURY_ENVIRONMENT = import.meta.env.VITE_TREASURY_ENVIRONMENT === "production" ? "production" : "trial";
const configuredProductionRoot: unknown = import.meta.env.VITE_TREASURY_PRODUCTION_ROOT;
export const TREASURY_PRODUCTION_ROOT = typeof configuredProductionRoot === "string" ? configuredProductionRoot : undefined;
if (TREASURY_ENVIRONMENT === "production" && !/^UQ[A-Za-z0-9_-]{46}$/.test(TREASURY_PRODUCTION_ROOT ?? "")) {
  throw new Error("treasury-production-root-required");
}

export function treasuryPurchaseStorageKey(userId: string): string {
  return `diamond-kingdom:vault-${TREASURY_ENVIRONMENT}:${TREASURY_ENVIRONMENT === "production" ? TREASURY_PRODUCTION_ROOT : TREASURY_TRIAL_ROOT}:${encodeURIComponent(userId)}`;
}
